export default "__VITE_ASSET__5yZxfP1e__"